import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import HomeListResults from "src/components/homes/HomeListResults";
import { connect } from "react-redux";
import { fetchHomes } from "src/actions/HomeActions";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#F5F6FA",
    minHeight: "100%",
    paddingTop: 24,
    paddingBottom: 48,
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 12,
  },
  pageTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: "#0F172A",
  },
  pageSubtitle: {
    fontSize: 14,
    color: "#64748B",
    marginTop: 2,
  },
  addButton: {
    backgroundColor: "#222222",
    color: "#FFFFFF",
    borderRadius: 8,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 1px 2px rgba(34, 34, 34, 0.3)",
    "&:hover": {
      backgroundColor: "#000000",
      boxShadow: "0 4px 12px rgba(34, 34, 34, 0.4)",
    },
  },
}));

const HomeList = ({ fetchHomes, homes }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    fetchHomes();
  }, [fetchHomes]);

  return (
    <>
      <Helmet>
        <title>Tubayo Host | Homes</title>
      </Helmet>
      <Box className={classes.root}>
        <Container maxWidth={false}>
          <Box className={classes.pageHeader}>
            <Box>
              <Typography className={classes.pageTitle}>Homes</Typography>
              <Typography className={classes.pageSubtitle}>
                Manage your listed properties
              </Typography>
            </Box>
            <Button
              className={classes.addButton}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/app/createHome")}
            >
              Add New Home
            </Button>
          </Box>
          <HomeListResults homes={homes} />
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  homes: state.homes.homes,
});

export default connect(mapStateToProps, { fetchHomes })(HomeList);
